import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import BasicGrid from "./detailGrid";
import "./details.scss";
import Loader from "../../../../components/Loader";
import CardNotFound from "./components/CardNotFound";
import errorIcon from "../../../../styles/svg/critical_priority.svg";
import { NavigationButtons } from "./components/desktop/NavigationButton";
import { MobileDrawer } from "./components/mobile/MobileDrawer";
import { CloseButton } from "./components/CloseButton";
import { useCardDialog } from "./components/hooks/useCardDialog";
import DialogHeader from "./components/DialogHeader";
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function CustomizedDialogs({
  data,
  cardId,
  boardId,
  cardsOfSameWorkflowStepId,
  showDetails,
  setShowDetails,
  cardsOnBoard,
}) {
  const {
    filterDrawer,
    isFocus,
    descriptionObj,
    cardTitle,
    descRef,
    isMobile,
    isBetween700And900,
    isCardLoading,
    isCardError,
    card,
    cardDetail,
    board_permission,
    checkIsOwnerOrAdmin,
    accessForDeleteCard,
    accessForEditCard,
    conditionCheck,
    handleClose,
    handleSave,
    handleReload,
    setFilterDrawer,
    setIsFocus,
    setCardTitle,
  } = useCardDialog({
    cardId,
    setShowDetails,
  });

  return (
    <>
      <BootstrapDialog
        aria-labelledby="customized-dialog-title"
        className={`card-detail-dialog ${isMobile ? "mobile-responsive-card-detail-container" : ""
          }`}
        open={showDetails}
        fullScreen={isMobile}
        sx={{
          zIndex: 1200,
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              height: isMobile ? "100vh" : "calc(100vh - 30px)",
              borderRadius: isMobile ? "" : "12px",
              margin: isMobile ? "auto" : "15px auto",
              maxWidth: "1180px",
            },
          },
        }}
      >
        {isCardLoading ? (
          <div className="loader-center">
            <Loader color={"black"} />
          </div>
        ) : isCardError ? (
          <CardNotFound
            title="The card you are looking for does not exist or has been
            deleted."
            btnTitle="Reload page"
            handleReload={handleReload}
            icon={errorIcon}
          />
        ) : (
          <>
            <DialogHeader
              cardDetail={cardDetail}
              cardId={cardId}
              boardId={cardDetail?.board_id}
              isMobile={isMobile}
              isBetween700And900={isBetween700And900}
              card={card}
              board_permission={board_permission}
              conditionCheck={conditionCheck}
              accessForDeleteCard={accessForDeleteCard}
              accessForEditCard={accessForEditCard}
              checkIsOwnerOrAdmin={checkIsOwnerOrAdmin}
              handleClose={handleClose}
              setShowDetails={setShowDetails}
            />
            <CloseButton
              isMobile={isMobile}
              onClose={handleClose}
              setFilterDrawer={setFilterDrawer}
              cardId={cardId}
              card={card}
            />
            <DialogContent dividers sx={{ paddingBottom: "50px !important" }}>
              <Typography gutterBottom>
                <BasicGrid
                  description={cardDetail?.description}
                  title={cardTitle}
                  cardId={cardId}
                  data={cardDetail}
                  descRef={descRef}
                  cardDescription={descriptionObj}
                  isfocus={setIsFocus}
                  handleDescriptionSave={handleSave}
                  setCardTitle={setCardTitle}
                  boardPermission={board_permission}
                />
              </Typography>
            </DialogContent>

            <NavigationButtons
              cardId={cardId}
              cardsOfSameWorkflowStepId={cardsOfSameWorkflowStepId}
            />
          </>
        )}
      </BootstrapDialog>
      {filterDrawer && (
        <MobileDrawer
          filterDrawer={filterDrawer}
          setFilterDrawer={setFilterDrawer}
          cardId={cardId}
          boardId={boardId}
          setShowDetails={setShowDetails}
          card={card}
          checkIsOwnerOrAdmin={checkIsOwnerOrAdmin}
          accessForEditCard={accessForEditCard}
          cardDetail={cardDetail}
          accessForDeleteCard={accessForDeleteCard}
        />
      )}
    </>
  );
}
